import Vue from 'vue';
import Vuetify from 'vuetify/lib'; 
import light from './wedrive';

import es from 'vuetify/lib/locale/es'
import en from 'vuetify/lib/locale/en'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: { light  }
    },
    lang: {
        locales: { es, en },
        current: 'en',
      },
});
